import { Navigate, NavigateProps } from 'react-router';
import usePermissions from '../../hooks/usePermissions';
import { NavigationTabOption } from '../../@types';
import useFeatureFlaggedTabs from '../../hooks/useFeatureFlaggedTabs';

type Props = Omit<NavigateProps, 'to'> & {
  tabs: NavigationTabOption[];
  fallback?: string;
};

const ProtectedNavigate = ({ tabs, fallback = '/', ...props }: Props) => {
  const { hasPermission } = usePermissions();
  const { filterFeatureFlaggedTabs } = useFeatureFlaggedTabs();

  const availableTabs = filterFeatureFlaggedTabs(tabs);
  const defaultTab = availableTabs.find((tab) => !tab.permission || hasPermission(tab.permission));

  return <Navigate to={defaultTab ? `./${defaultTab.value}` : fallback} {...props} />;
};

export default ProtectedNavigate;
